import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Optional,
  Output,
  ViewChild,
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { saveAs } from 'file-saver/FileSaver';
import { AuthService } from '../../../../shared/services/auth/auth.service';
import { MIN_STATUS } from '../../../../shared/utils/constants';
import { ModalComponent } from '../../../../vass-core/components/modal/modal.component';
import { CommonService } from '../../../../vass-core/services/common.service';
import { DocumentSaveModel } from '../../../models/documentSave.model';
import { DocumentationService } from '../../../services/documentation/documentation.service';
@Component({
  selector: 'app-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.scss'],
  standalone: false,
})
export class UploadFileComponent implements OnInit {
  public maxFileSize = 11;
  public maxSizename = 200;
  public supportedFiles = 'image/jpg,image/png,image/jpeg,application/pdf';
  private sendFile = false;
  public listDocuments = [];
  public httpError = false;
  public filesNotType = false;
  public itemSelected: DocumentSaveModel = null;
  public canUpload: boolean = true;
  public loading: boolean = true;
  public resizing = false;
  public status = 0;
  public ALL_STATUS = MIN_STATUS;

  @Input() category: string = 'MTG_C02';
  @Input() type: string = 'DOC_20';
  @Input() searchByCategory = true;
  @Input() holder: string;
  @ViewChild('inputFile') inputFile;
  @Output() onSendFile: EventEmitter<any> = new EventEmitter();
  @Output() onErrorUploadFile: EventEmitter<any> = new EventEmitter();

  listDocumentTypes = [];
  formUpload: UntypedFormGroup;
  // private modalComponent: ModalComponent;
  public fileUpload: FileUploadModel;
  public showError = false;
  public showInfo = false;
  public errorFile = {
    hasError: false,
    msgError: '',
  };

  constructor(
    private formBuilder: UntypedFormBuilder,
    private documentService: DocumentationService,
    private translate: TranslateService,
    private _commonService: CommonService,
    private authService: AuthService,
    @Optional() private modalComponent: ModalComponent,
  ) {
    if (this.modalComponent) {
      this.listDocumentTypes =
        !!this.modalComponent.data && !!this.modalComponent.data.listDocuments
          ? this.modalComponent.data.listDocuments
          : [];
      this.category =
        !!this.modalComponent.data && !!this.modalComponent.data.category
          ? this.modalComponent.data.category
          : '';
      this.type =
        !!this.modalComponent.data && !!this.modalComponent.data.type
          ? this.modalComponent.data.type
          : '';
      this.holder =
        !!this.modalComponent.data && !!this.modalComponent.data.holder
          ? this.modalComponent.data.holder
          : undefined;
      this.filesNotType =
        !!this.modalComponent.data && !!this.modalComponent.data.filesNotType
          ? this.modalComponent.data.filesNotType
          : false;
      this.canUpload =
        !!this.modalComponent.data && this.modalComponent.data.hasOwnProperty('canUpload')
          ? this.modalComponent.data.canUpload
          : true;
      this.searchByCategory =
        !!this.modalComponent.data &&
        this.modalComponent.data.hasOwnProperty('searchByCategory')
          ? this.modalComponent.data.searchByCategory
          : true;
      this.mapperList(this.listDocumentTypes);
    }
  }

  ngOnInit() {
    this.createForm();
    this.getStatus();
    // Solo recupero los datos si voy a subir desde la modal
    if (this.modalComponent) {
      this.getDocumentationByType();
    }
  }

  private getStatus() {
    this.authService.getStatus().subscribe((response) => {
      this.status = parseFloat(response);
    });
  }

  createForm() {
    this.formUpload = this.formBuilder.group({
      documentDesc: [''],
      finishUpload: [],
      file: ['', Validators.required],
    });
  }

  click() {
    this.sendFile = true;
    this.inputFile.nativeElement.click();
  }

  uploadImg(event: any) {
    this.showError = false;
    const maxBytes = this.maxFileSize * 1048576;
    let imgData = event.target.files[0];
    this.fileUpload = { name: '', icon: '', size: 0 };
    if (event.target.value === '') {
      // Internet explorer vuelve a entrar y da error porque no manda nada
      if (this.formUpload.controls.file.value !== '') {
        imgData = this.formUpload.controls.file.value;
      } else {
        return;
      }
    }
    if (imgData && !this.machingTypes(imgData.name)) {
      this.errorFile.hasError = true;
      this.errorFile.msgError = this.translate.instant(
        'upload_file_error_invalid_format',
      );
      this.formUpload.controls.file.setValue('');
    } else if (imgData && imgData.size > maxBytes) {
      this.errorFile.hasError = true;
      this.errorFile.msgError = this.translate
        .instant('upload_file_error_maxSize')
        .replace('{0}', this.maxFileSize);
    } else if (imgData.name.length > this.maxSizename) {
      this.errorFile.hasError = true;
      this.errorFile.msgError = this.translate
        .instant('upload_file_error_maxSize_name')
        .replace('{0}', this.maxSizename);
    } else {
      this.errorFile.hasError = false;
      this.errorFile.msgError = '';
      this.formUpload.controls.file.setValue(imgData);
      this.resizing = true;
      this.mapperFile(imgData);
    }
    if (this.sendFile) {
      if (this.errorFile.hasError) {
        this.onErrorUploadFile.emit({
          hasError: this.errorFile.hasError,
          msgError: this.errorFile.msgError,
        });
      } else {
        this.onSendFile.emit({
          documentDesc: this.formUpload.controls.documentDesc.value,
          category: this.category,
          type: this.type,
          file: this.formUpload.controls.file.value,
          holder: this.holder,
          name: imgData.name,
          icon: this.getIcon(imgData),
          size: imgData.size,
        });
      }
      event.target.value = ''; // Se resete para poder enviar el mismo fichero si falla la subida
    }
  }

  machingTypes(nameFile: string) {
    const extFile = nameFile.split('.');
    if (
      this.supportedFiles.indexOf(extFile[extFile.length - 1].toLocaleLowerCase()) === -1
    ) {
      return false;
    }
    return true;
  }

  mapperFile(file) {
    this.fileUpload = {
      name: file.name,
      icon: this.getIcon(file),
      size: file.size,
    };
    return file;
  }

  getIcon(file) {
    switch (file.type) {
      case 'image/jpeg':
      case 'image/png': {
        const reader = new FileReader();
        reader.onload = (readerEvent) => {
          const myImage = new Image();
          myImage.src = String(reader.result);
          myImage.onload = () => {
            this.fileUpload.icon = this.resize(myImage);
            this.resizing = false;
          };
          myImage.onerror = (err) => {
            this.errorFile.hasError = true;
            this.errorFile.msgError = this.translate.instant(
              'modal_upload_file_error_upload_img',
            );
            this.resizing = false;
          };
        };
        reader.readAsDataURL(file);
        break;
      }
      case 'application/pdf': {
        this.resizing = false;
        return './assets/img/doc-pending.svg';
      }
      case 'application/x-zip-compressed': {
        this.resizing = false;
        return './assets/img/doc-pending.svg';
      }
      default: {
        this.resizing = false;
        return './assets/img/doc-pending.svg';
      }
    }
  }

  finishUpload() {
    this.showError = false;
    if (this.formUpload.valid) {
      const formData = new FormData();
      formData.append('documentType', this.type);
      formData.append('documentDesc', this.formUpload.controls.documentDesc.value);
      formData.append('category', this.category);
      formData.append('file', this.formUpload.controls.file.value);

      this.documentService.uploadDocuments(formData, this.holder).subscribe(
        (data) => {
          this.modalComponent.sendDataFromModal({ action: 'add-file' }, { hide: false });
          this.getDocumentationByType();
          this.fileUpload = null;
          this.inputFile.nativeElement.value = '';
          this.createForm();
        },
        (err) => {
          this.showError = true;
        },
      );
    } else {
      for (const campo in this.formUpload.controls) {
        this.formUpload.controls[campo].markAsTouched();
      }
    }
  }

  mapperList(list) {
    const newList = [];
    list.forEach((element) => {
      newList.push({ label: element.name, value: element.code });
    });
    this.listDocumentTypes = newList;
  }

  resize(img, MAX_WIDTH: number = 130, MAX_HEIGHT: number = 130): string {
    const canvas = document.createElement('canvas');
    let width = img.width;
    let height = img.height;

    if (width > height) {
      if (width > MAX_WIDTH) {
        height *= MAX_WIDTH / width;
        width = MAX_WIDTH;
      }
    } else {
      if (height > MAX_HEIGHT) {
        width *= MAX_HEIGHT / height;
        height = MAX_HEIGHT;
      }
    }
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0, width, height);
    const dataUrl: string = canvas.toDataURL(img.type);
    return dataUrl;
  }

  openToast(id: string) {
    const elementHTML = document.getElementById(id);
    elementHTML.focus();
  }

  deleteFile(fileId: string) {
    this.documentService.deleteFile(fileId).subscribe(
      (data) => {
        const index = this.listDocuments.findIndex((e) => e.fileId === fileId);
        if (index > -1) {
          this.listDocuments.splice(index, 1);
        }
        this.itemSelected = null;
        this.getDocumentationByType();
        this.modalComponent.sendDataFromModal({ action: 'delete-file' }, { hide: false });
      },
      (err) => {
        this._commonService.sendNotification({
          key: 'delete-error',
          severity: 'error',
          position: 'top-center',
          summary: this.translate.instant('app_advance_simulator_error_save_form_title'),
          time: 5000,
          detail: this.translate.instant('upload_file_error_delete_file'),
        });
      },
    );
  }

  getDocumentationByType() {
    let category: string;
    let type: string;
    let holder: string;
    if (!this.filesNotType) {
      category = this.searchByCategory ? this.category : undefined;
      type = this.type;
      holder = this.holder;
    }
    this.documentService.getDocumentationSave(category, type, holder).subscribe(
      (documentation) => {
        this.listDocuments = documentation;
        this.loading = false;
      },
      (error) => {
        this.httpError = true;
      },
    );
  }

  showConfirmDelete(item: DocumentSaveModel) {
    this.itemSelected = item;
  }

  downloadFile(document: DocumentSaveModel) {
    document['downloading'] = true;
    this.documentService.downloadFile(document.fileId).subscribe(
      (data) => {
        saveAs(data, document.name);
        document['downloading'] = false;
      },
      (err) => {
        document['downloading'] = false;
      },
    );
  }
}

interface FileUploadModel {
  name: string;
  icon: string;
  size: number;
}
